import GameStatusBar from "./StatusBar";
import "./status-bar.scss";

export default GameStatusBar;
